import {API_URL, apiPost, apiPut} from '../api'

export const editTraderMap = async data => {
    return await apiPut(API_URL, 'admin/trader/project', data)
}
